import { pipe } from 'fp-ts/lib/function';
import { failure, number, parse, string, success, union } from 'io-ts/lib/Decoder';

export const EncodedNumber = pipe(
	union(string, number),
	parse((s) => {
		const parsed = parseInt(`${s}`, 10);

		if (isNaN(parsed)) {
			return failure(parsed, 'NaN');
		}

		return success(parsed);
	})
);

export const PositiveInteger = pipe(
	number,
	parse((s) => {
		const parsed = parseInt(`${s}`, 10);

		if (isNaN(parsed)) {
			return failure(parsed, 'NaN');
		}

		if (parsed !== s) {
			return failure(parsed, 'integer');
		}

		if (parsed < 0) {
			return failure(parsed, 'positive');
		}

		return success(parsed);
	})
);

/** A positive integer no greater than `max` — for request fields that size a response. */
export const PositiveIntegerUpTo = (max: number) =>
	pipe(
		PositiveInteger,
		parse((s) => (s > max ? failure(s, `at most ${max}`) : success(s)))
	);

export const PositiveInteger1Based = pipe(
	PositiveInteger,
	parse((s) => {
		if (s === 0) {
			return failure(s, 'non-zero');
		}

		return success(s);
	})
);

export const StringNumber = pipe(
	union(string, number),
	parse((s) => {
		const n = Number(s);
		return !isNaN(n) ? success(n) : failure(s, 'must be a number');
	})
);

export const NaNOrNumber = pipe(
	union(string, number),
	parse((s) => (s === 'NaN' ? success(NaN) : number.decode(s)))
);

export const NormalizedCoordinate = pipe(
	number,
	parse((s) => {
		const n = Number(s);

		if (isNaN(n)) {
			return failure(s, 'must be a number');
		}

		if (n < 0 || n > 1) {
			return failure(s, 'must be a normalized coordinate in the range [0, 1]');
		}

		return success(n);
	})
);
